import { render, staticRenderFns } from "./ItemCombo.vue?vue&type=template&id=df15b786"
import script from "./ItemCombo.vue?vue&type=script&lang=js"
export * from "./ItemCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports